import React from 'react'

export interface InvisibleRadioButtonProps {
  label: string
  optionValue: string
  selectedValue: string
  groupName?: string
}

/**
 * Example with two radio buttons (in the same group)
 * const selectedOption = 'option-2'
 * <InvisibleRadioButton itemLabel='Option 1' itemType='option-1' selectionType={selectedOption} groupName='group' />
 * <InvisibleRadioButton itemLabel='Option 2' itemType='option-1' selectionType={selectedOption} groupName='group'/>
 * @param label User visible label
 * @param optionValue  Option value to pass when this item is selected
 * @param selectedValue The currently selected value (to indicate whether the button is active or not)
 * @param groupName The name of the group this radio button belongs to
 * @constructor
 */
export const InvisibleRadioButton: React.FC<InvisibleRadioButtonProps> = (
  { label, optionValue, selectedValue, groupName }
) => {
  const group = groupName ?? 'invisible-radio-group'
  const isActive = optionValue === selectedValue

  const itemClass = isActive ? 'item active' : 'item'

  return (
    <label className='invisible-radio'>
      <input className='invisible-radio' type='radio' name={group} value={optionValue} defaultChecked={isActive} />
      <span className={itemClass}>{label}</span>
    </label>
  )
}
